/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Grid,
} from '@material-ui/core';

export default function Edit({
  openEdit,
  setOpenEdit,
  loadingEdit,
  handleEdit,
  name,
  setName,
}) {
  return (
    <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
      <DialogTitle>Editar Categoria</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Nome"
              variant="outlined"
              fullWidth
              value={name}
              onChange={e => setName(e.target.value)}
              inputProps={{ maxLength: 255 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button onClick={() => setOpenEdit(false)} disabled={loadingEdit}>
          Cancelar
        </Button>
        <Button
          onClick={handleEdit}
          variant="contained"
          color="primary"
          disabled={loadingEdit}
        >
          {loadingEdit ? <CircularProgress size={22} /> : 'Salvar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}